<template>
  <div>
    <article-entry-no-image :textElements="article" />
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 pb-4" v-for="(resume, i) in resumes" :key="'resume' + i">
          <div class="resume">
            <div class="team-containt">
              <h3>{{ resume.title }}</h3>
              <p>{{ resume.subTitle }}</p>
              <router-link :to="resume.link"
                >Learn more<i class="far fa-long-arrow-alt-right"></i
              ></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArticleEntryNoImage from '@/components/ArticleEntryNoImage';
import { getPage } from '@/api/navItems';
import { translate } from '@/lib/utils';
export default {
  components: {
    ArticleEntryNoImage
  },
  mounted() {
    getPage(this.$route.meta.page).then(res => {
      this.article = translate(res[0]);
      // Extract resume
      this.resumes = res[0].content.filter(elt => elt.__component == 'content.resume');
    });
  },
  data() {
    return {
      article: {},
      resumes: []
    };
  },
  computed: {},
  methods: {}
};
</script>

<style scoped>
.resume {
  min-height: 300px;
  background: #fff;
  box-shadow: 0 0 10px #1425411a;
  border-radius: 8px;
  padding: 60px;
}
</style>
